export interface AvatarOption {
	id: string;
	label: string;
	emoji: string;
	gradient: string;
}

export const AVATAR_OPTIONS: AvatarOption[] = [
	{
		id: "speed-raccoon",
		label: "Avatar 1",
		emoji: "🦝",
		gradient: "linear-gradient(135deg, #334155, #0f172a)",
	},
	{
		id: "turbo-tiger",
		label: "Avatar 2",
		emoji: "🐯",
		gradient: "linear-gradient(135deg, #f97316, #ea580c)",
	},
	{
		id: "rocket-panda",
		label: "Avatar 3",
		emoji: "🐼",
		gradient: "linear-gradient(135deg, #64748b, #1e293b)",
	},
	{
		id: "drift-fox",
		label: "Avatar 4",
		emoji: "🦊",
		gradient: "linear-gradient(135deg, #fb7185, #f43f5e)",
	},
	{
		id: "nitro-koala",
		label: "Avatar 5",
		emoji: "🐨",
		gradient: "linear-gradient(135deg, #22d3ee, #0ea5e9)",
	},
	{
		id: "storm-owl",
		label: "Avatar 6",
		emoji: "🦉",
		gradient: "linear-gradient(135deg, #818cf8, #4f46e5)",
	},
	{
		id: "trail-bear",
		label: "Avatar 7",
		emoji: "🐻",
		gradient: "linear-gradient(135deg, #a16207, #854d0e)",
	},
	{
		id: "bolt-frog",
		label: "Avatar 8",
		emoji: "🐸",
		gradient: "linear-gradient(135deg, #22c55e, #15803d)",
	},
	{
		id: "zoom-monkey",
		label: "Avatar 9",
		emoji: "🐵",
		gradient: "linear-gradient(135deg, #f59e0b, #d97706)",
	},
	{
		id: "wheelie-cat",
		label: "Avatar 10",
		emoji: "🐱",
		gradient: "linear-gradient(135deg, #06b6d4, #0e7490)",
	},
	{
		id: "flash-bunny",
		label: "Avatar 11",
		emoji: "🐰",
		gradient: "linear-gradient(135deg, #d946ef, #a21caf)",
	},
	{
		id: "track-penguin",
		label: "Avatar 12",
		emoji: "🐧",
		gradient: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
	},
	{
		id: "dash-wolf",
		label: "Avatar 13",
		emoji: "🐺",
		gradient: "linear-gradient(135deg, #475569, #1e293b)",
	},
	{
		id: "blaze-lion",
		label: "Avatar 14",
		emoji: "🦁",
		gradient: "linear-gradient(135deg, #f59e0b, #b45309)",
	},
	{
		id: "glide-deer",
		label: "Avatar 15",
		emoji: "🦌",
		gradient: "linear-gradient(135deg, #65a30d, #3f6212)",
	},
	{
		id: "rapid-dolphin",
		label: "Avatar 16",
		emoji: "🐬",
		gradient: "linear-gradient(135deg, #0ea5e9, #1e40af)",
	},
	{
		id: "cruise-lizard",
		label: "Avatar 17",
		emoji: "🦎",
		gradient: "linear-gradient(135deg, #10b981, #047857)",
	},
	{
		id: "orbit-hamster",
		label: "Avatar 18",
		emoji: "🐹",
		gradient: "linear-gradient(135deg, #fb7185, #be123c)",
	},
	{
		id: "spark-octopus",
		label: "Avatar 19",
		emoji: "🐙",
		gradient: "linear-gradient(135deg, #f43f5e, #7e22ce)",
	},
	{
		id: "jump-parrot",
		label: "Avatar 20",
		emoji: "🦜",
		gradient: "linear-gradient(135deg, #22c55e, #0f766e)",
	},
	{
		id: "rush-shark",
		label: "Avatar 21",
		emoji: "🦈",
		gradient: "linear-gradient(135deg, #0891b2, #1e3a8a)",
	},
	{
		id: "climb-goat",
		label: "Avatar 22",
		emoji: "🐐",
		gradient: "linear-gradient(135deg, #8b5cf6, #4338ca)",
	},
	{
		id: "swirl-unicorn",
		label: "Avatar 23",
		emoji: "🦄",
		gradient: "linear-gradient(135deg, #ec4899, #7c3aed)",
	},
	{
		id: "chase-dog",
		label: "Avatar 24",
		emoji: "🐶",
		gradient: "linear-gradient(135deg, #f97316, #9a3412)",
	},
];

export const DEFAULT_AVATAR_ID = AVATAR_OPTIONS[0].id;

export const getAvatarOptionById = (avatarId?: string) =>
	AVATAR_OPTIONS.find((option) => option.id === avatarId) ?? AVATAR_OPTIONS[0];
